import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getJobOpeningsById } from "../../../ApiServices/ApiServices";
import CodeQueueSpinner from "../../../Utils";
const JobDetail = () => {
  const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const jobId = queryParams.get("jobId");

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const job = await getJobOpeningsById(jobId);
        setJob(job?.job);
        setLoading(false);
      } catch (error) {
        setError(error?.response?.data?.message || "Error fetching jobs");
        setLoading(false);
      }
    };
    fetchJobs();
  }, [jobId]);

  const handleApply = () => {
    navigate(`/jobs/${jobId}/apply`, {
      state: { jobId, jobtitle: job?.title },
    });
  };

  return (
    <div className="p-8 bg-gray-100 min-h-screen">
      <button
        onClick={() => navigate(-1)}
        className="text-blue-600 font-medium mb-6"
      >
        &lt; Back To All Jobs
      </button>

      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="bg-blue-500 text-white rounded-t-lg p-6">
          <h1 className="text-2xl font-bold">
            {job?.title || "Job Title Not Available"}
          </h1>
          <p className="text-sm mt-2">Job ID: {job?.jobId || "N/A"}</p>
          <div className="flex items-center justify-between mt-4">
            <p className="text-sm">
              📍 {job?.locations?.join(", ") || "Location not available"}
            </p>
            <p className="text-sm">
              🕒 Posted Date : {job?.postedDate || "N/A"}
            </p>
            {/* <p className="text-sm">
              🕒 Expires on {job?.expiryDate || "N/A"}
            </p> */}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <div className="flex items-center bg-gray-50 rounded-lg p-4 border">
            <div className="text-orange-500 text-2xl mr-4">👨‍💻</div>
            <div>
              <h3 className="text-sm text-gray-500">Required Experience</h3>
              <p className="text-lg font-bold">
                {job?.experience || "Not specified"}
              </p>
            </div>
          </div>
          <div className="flex items-center bg-gray-50 rounded-lg p-4 border">
            <div className="text-blue-500 text-2xl mr-4">⭐</div>
            <div>
              <h3 className="text-sm text-gray-500">Skills</h3>
              <p className="text-lg font-bold">
                {job?.skills?.length > 0
                  ? job.skills.join(", ")
                  : "No skills listed"}
              </p>
            </div>
          </div>
        </div>

        <div className="mt-6">
          <h3 className="text-lg font-semibold mb-4">Responsibilities:</h3>
          <ul className="list-disc pl-5 text-gray-700 space-y-2">
            {job?.responsibilities?.length > 0 ? (
              job?.responsibilities?.map((point, index) => (
                <li key={index}>{point}</li>
              ))
            ) : (
              <li>No responsibilities listed</li>
            )}
          </ul>
          {loading && <CodeQueueSpinner />}
        </div>

        <div className="mt-6 flex justify-center">
          <button
            onClick={handleApply}
            className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default JobDetail;
